import React from 'react';
import AdminCoupon from '../components/AdminCoupon';

const AdminCouponContainer = () => {
  return <AdminCoupon />;
};

export default AdminCouponContainer;
